import React from 'react';
import { Common } from '../..';
import { appConfig as $config } from '../../app.config';
import { fUploader } from '../../modules/fUploader';

export const importSalesOrder = (function () {
  let $fup = null,
    $notificationAlert,
    modalContent,
    $uploadBtn,
    $startImportCallback,
    $pageType;

  let dialog = ($event, startImportCallback = null, pageType = 'Orders', isParentAccountImport = false) => {
    $startImportCallback = startImportCallback;
    $pageType = pageType;
    let template = pageType === 'Boms' ? require('./tmpl/dialog/addfileBOM.hbs') : require('./tmpl/dialog/addfile.hbs');

    bootbox
      .dialog({
        title: pageType === 'Boms' ? $lang.BOM.ImportBOM : $lang.orders.ImportSalesOrder,
        message: template({ $lang: $Lang }),
        size: 'large',
        className: 'modal-importSalesOrder',
        buttons: {
          ok: {
            label: $lang.btn.Import,
            className: 'btn btn-brand importSales-upload-button',
            callback: uploadStart
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => dialogInit(startImportCallback, pageType, isParentAccountImport));
  };

  let dialogInit = (startImportCallback, pageType, isParentAccountImport) => {
    modalContent = '.modal-importSalesOrder .modal-content';
    $uploadBtn = $('.modal-importSalesOrder .importSales-upload-button');
    $notificationAlert = $('.modal-importSalesOrder #notificationAlert');

    // Download Orders Import Template
    $('.modal-importSalesOrder .js-action-downloadSalesTemplate').on('click', (e) => {
      let templateData;
      switch (true) {
        case pageType === 'Boms' && e.target?.classList?.contains('js-full-BOM'): {
          templateData = {
            templateFile: $config.fileTemplates.bomImportFull.link,
            templateName: $config.fileTemplates.bomImportFull.name
          };
          break;
        }
        case pageType === 'Boms' && e.target?.classList?.contains('js-lean-BOM'): {
          templateData = {
            templateFile: $config.fileTemplates.bomImportLean.link,
            templateName: $config.fileTemplates.bomImportLean.name
          };
          break;
        }
        default: {
          templateData = {
            templateFile: $config.fileTemplates.orderImport.link,
            templateName: $config.fileTemplates.orderImport.name
          };
          break;
        }
      }
      Common.saveFile($config.apiURL + templateData.templateFile, templateData.templateName);
    });

    fupInit(startImportCallback, pageType, isParentAccountImport);
  };

  const fupInit = (startImportCallback, pageType, isParentAccountImport) => {
    $uploadBtn.prop('disabled', true);

    $fup = new fUploader('input[type="file"]', {
      extensions: ['xlsx'],
      suitabilityViewExtensions: ['xlsx'],
      pageType,
      blockEl: modalContent,
      isParentAccountImport,
      complete: (file) => {
        if (startImportCallback) {
          startImportCallback(file[0].uri);
        } else {
          importSalesOrder(file);
        }
      },
      validate: (data) => {
        $notificationAlert.empty().hide();
        $uploadBtn.prop('disabled', !data);
      }
    });
  };

  let uploadStart = (e) => {
    $fup.uploadStart();
    return false;
  };

  let reloadOrders = () => {
    if ($.fn.dataTable.isDataTable('#LineItemsDataTable')) {
      $('#LineItemsDataTable').DataTable().draw();
    }
  };

  return {
    dialog,
    closeDialog: bootbox.hideAll,
    reloadOrders: reloadOrders
  };
})();
